import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import successAnimation from "../../animations/check.json";
import errorAnimation from "../../animations/error.json";
import { useLocation, useNavigate } from "react-router-dom";
import { formatterAmount } from "../../utils/utilidades";
import moment from "moment";
import { useTranslation } from "react-i18next";

const SubscriptionTransition = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [t] = useTranslation("global");
  const [animationComplete, setAnimationComplete] = useState(false);
  const animationData = state?.isSuccess ? successAnimation : errorAnimation;
  const backgroundColor = state?.isSuccess ? "bg-[#13c894]" : "bg-[#FF6347]";

  console.log("Que valores recibo desde el state", state);

  useEffect(() => {
    setTimeout(() => setAnimationComplete(true), 2000);
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-hidden">
      {/* Expansión del fondo con Framer Motion */}
      <motion.div
        initial={{ width: 100, height: 100, borderRadius: "50%" }}
        animate={{ width: "100vw", height: "100vh", borderRadius: "0%" }}
        transition={{ duration: 0.5 }}
        className={`absolute inset-0 ${backgroundColor} flex items-center justify-center`}
      ></motion.div>

      {/* Animación Lottie */}
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9 }}
        className="relative z-10 flex justify-center items-center w-[200px] h-[200px] md:w-[300px] md:h-[300px] lg:w-[350px] lg:h-[350px]"
      >
        <Lottie animationData={animationData}  loop={false}  className="h-[50rem] w-[50rem]" />
      </motion.div>

      {/* Mostrar información después de la animación */}
      {animationComplete && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="absolute z-20 w-[90%] max-w-[450px] bg-white rounded-lg p-6 shadow-lg"
        >
          {!state?.isSuccess ? (
            <div className="text-center">
              <h2 className="text-2xl font-bold text-red-600">{t("finishPayment.badTitle")}</h2>
              <p className="mt-2 text-gray-600">{t("finishPayment.description")}</p>
              <p className="text-gray-500">{t("finishPayment.description2")}</p>
              <button
                className="w-full px-6 py-3 mt-4 font-semibold text-white bg-red-500 rounded-lg shadow-md hover:bg-red-600"
                onClick={() => navigate(-1)}
              >
                {t("finishPayment.Buttons.again")}
              </button>
            </div>
          ) : (
            <div className="text-center">
              <h2 className="text-2xl font-bold text-green-600">{t("finishPayment.title")}</h2>
              <div className="w-full h-[2px] bg-gray-200 my-4"></div>

              <p className="text-lg font-medium text-gray-700">
                {t("finishPayment.Description.planName")}: {state.suscriptionData.subscriptionName}
              </p>
              <p className="text-lg font-medium text-gray-700">
                Precio: {formatterAmount(state.suscriptionData.amount, state.suscriptionData.currency)} {state.suscriptionData.currency}
              </p>
              <p className="font-medium text-gray-600 text-md">
                {t("finishPayment.Description.payMethod")}: {t("finishPayment.Description.creditCard")}
              </p>
              <p className="font-medium text-gray-600 text-md">
                {t("finishPayment.Description.startDate")}: {moment(state.suscriptionData.start_date).format("DD MMM YYYY")}
              </p>
              <p className="font-medium text-gray-600 text-md">
                {t("finishPayment.Description.nextPayment")}: {moment(state.suscriptionData.next_payment).add(1, "month").format("DD MMM YYYY")}
              </p>

              <span className="block mt-2 text-xs text-gray-500">{t("finishPayment.information")}</span>

              {/* Botones de acción */}
              <div className="flex flex-col items-center justify-center gap-4 mt-6 sm:flex-row">
                <button
                  className="w-full px-6 py-3 font-semibold text-white bg-black rounded-lg shadow-md sm:w-auto hover:bg-gray-800"
                  onClick={() => navigate("/perfil")}
                >
                  {t("finishPayment.Buttons.viewAccount")}
                </button>
                <button
                  className="w-full px-6 py-3 font-semibold text-black bg-gray-200 rounded-lg shadow-md sm:w-auto hover:bg-gray-300"
                  onClick={() => navigate("/")}
                >
                  {t("finishPayment.Buttons.back")}
                </button>
              </div>
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export default SubscriptionTransition;
